<mat-accordion class="menu-headers-align" multi>
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Problèmes
        </mat-panel-title>
        <mat-panel-description>
            <fa-icon [icon]="['fas', 'hand-holding-heart']" size="lg"></fa-icon>
          <mat-icon></mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <app-problem-list [location]="'menuright'"></app-problem-list>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Traitements
          </mat-panel-title>
          <mat-panel-description>
            <fa-icon [icon]="['fas', 'pills']" size="lg"></fa-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <app-medication-list [location]="'menuright'"></app-medication-list>
      </mat-expansion-panel>
  </mat-accordion>